jQuery(function($) {
    $( document ).ready(function() {

        gsap.registerPlugin(ScrollTrigger);


        const lenis = new Lenis({
            smooth: true,
            infinite: false
        });

        let st;
        let ft;

        lenis.on('scroll',()=>{
          ScrollTrigger.update()
        })
        
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        
        const items = document.querySelectorAll('.slider-vertical .slides .slide');
        const itemsNotLast = Array.from(items).slice(0,-1) 

        let imgScale = 0.7
        let anim1Stop = "80%"
        let anim2Start = "80%"
        if(items) {

            itemsNotLast.forEach((item) => {

                let img = item.querySelector('img');
                let title = item.querySelector('h2');
    

                if(title) {

    
                    ft = gsap.timeline()
                    .to(img, {
                        ease: "none",
                        onStart: () => {
                            if (st) st.kill();
                        },
                        startAt: { scale: imgScale},
                        scale: 1,
                        filter: 'blur(0px)',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top bottom',
                            end: `center ${anim1Stop}`,
                            scrub: true,
                            onEnter: () => gsap.set(img, { transformOrigin: '50% 0%'  }),
                            onEnterBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                            onLeave: () => gsap.set(img, { transformOrigin: '50% 100%'}),
                            onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                        },
                    })
                    .to(title, {
                        ease: "none",
                        onStart: () => {
                            if (st) st.kill();
                        },
                        startAt: { opacity: 0, top: '150px' },
                        opacity: 1,
                        top: '25px',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top bottom',
                            end: 'center center',
                            scrub: true,
                        },
                    })
                } else {
                    ft = gsap.timeline()
                    .to(img, {
                        ease: "none",
                        onStart: () => {
                            if (st) st.kill();
                        },
                        startAt: { scale: imgScale},
                        scale: 1,
                        filter: 'blur(0px)',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top bottom',
                            end: `center ${anim1Stop}`, 
                            scrub: true,
                            onEnter: () => gsap.set(img, { transformOrigin: '50% 0%'  }),
                            onEnterBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                            onLeave: () => gsap.set(img, { transformOrigin: '50% 100%'}),
                            onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                        },
                    })
                }
        
        
                st = gsap.timeline()
                    .to(img, {
                        ease: "none",
                        onStart: () => {
                            if (ft) ft.kill();
                        },
                        startAt: { scale: 1 },
                        scale: imgScale,
                        scrollTrigger: {
                            trigger: item,
                            start:`${anim2Start} center`, 
                            end: 'bottom top',
                            scrub: true,
                            onEnter: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                            onEnterBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                            onLeave: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                            onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                        },
                    })
                    
            });
          
            // Last item's animation
            var itemsLength = items.length;
            var lastItem = items[itemsLength - 1];
            let title;
            let img;
            if(lastItem) {
                img = lastItem.querySelector('img');
                title = lastItem.querySelector('h2');
            }
            if(title) {
                ft = gsap.timeline()
                .to(img, {
                    ease: "none",
                    onStart: () => {
                        if (st) st.kill();
                    },
                    startAt: { scale: imgScale},
                    scale: 1,
                    filter: 'blur(0px)',
                    scrollTrigger: {
                        trigger: lastItem,
                        start: 'top bottom',
                        end: 'center center',
                        scrub: true,
                        onEnter: () => gsap.set(img, { transformOrigin: '50% 0%'  }),
                        onEnterBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                        onLeave: () => gsap.set(img, { transformOrigin: '50% 100%'}),
                        onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                    },
                })
                .to(title, {
                    ease: "none",
                    onStart: () => {
                        if (st) st.kill();
                    },
                    startAt: { opacity: 0, top: '150px' },
                    opacity: 1,
                    top: '25px',
                    scrollTrigger: {
                        trigger: lastItem,
                        start: 'top bottom',
                        end: 'center center',
                        scrub: true,
                    },
                })
            } else {
    
                ft = gsap.timeline()
                    .to(img, {
                        ease: "none",
                        onStart: () => {
                            if (st) st.kill();
                        },
                        startAt: { scale: imgScale},
                        scale: 1,
                        filter: 'blur(0px)',
                        scrollTrigger: {
                            trigger: lastItem,
                            start: 'top bottom',
                            end: 'center center',
                            scrub: true,
                            onEnter: () => gsap.set(img, { transformOrigin: '50% 0%'  }),
                            onEnterBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                            onLeave: () => gsap.set(img, { transformOrigin: '50% 100%'}),
                            onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                        },
                    })
    
            }
        
        
            st = gsap.timeline()
                .to(img, {
                    ease: "none",
                    onStart: () => {
                        if (ft) ft.kill();
                    },
                    startAt: { scale: 1 },
                    scale: 1,
                    scrollTrigger: {
                        trigger: lastItem,
                        start: 'center center',
                        end: 'bottom top',
                        scrub: true,
                        onEnter: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                        onEnterBack: () => gsap.set(img, { transformOrigin: '50% 100%' }),
                        onLeave: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                        onLeaveBack: () => gsap.set(img, { transformOrigin: '50% 0%' }),
                    },
                })
            requestAnimationFrame(raf);

        }

        
            
        
        

});
});
